import { render, staticRenderFns } from "./VideosList.vue?vue&type=template&id=67c07fcc&scoped=true&"
import script from "./VideosList.vue?vue&type=script&lang=js&"
export * from "./VideosList.vue?vue&type=script&lang=js&"
import style0 from "./VideosList.vue?vue&type=style&index=0&id=67c07fcc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c07fcc",
  null
  
)

export default component.exports